<template>
  <v-app>
    <div class="media-exit-order-history-page">
      <v-container>
        <div class="media-exit-order-filter">
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header
                :hide-actions="true"
                @click="expand = !expand"
                class="filter-header"
              >
                <v-row no-gutters>
                  <v-col class="d-flex justify-space-between">
                    <div class="media-exit-order">Order History</div>
                    <div class="media-exit-filter-box d-flex">
                      <span class="mx-1">Filter</span>
                      <span class="arrow" :class="expandarrow" />
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="8" sm="6" md="8" class="mt-3">
                    <v-text-field
                      label="Subject"
                      v-model="filterObject.subject"
                      dense
                      @keyup.enter="validate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" sm="6" md="4" class="mt-3">
                    <v-text-field
                      label="File Name"
                      v-model="filterObject.filename"
                      dense
                      @keyup.enter="validate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" sm="6" md="4" class="pt-0">
                    <v-text-field
                      label="Sender Email"
                      v-model="filterObject.email_from"
                      dense
                      @keyup.enter="validate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" sm="6" md="4" class="pt-0">
                    <v-text-field
                      label="Receiver Email"
                      v-model="filterObject.receiver_mail"
                      dense
                      @keyup.enter="validate"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" sm="6" md="4" class="pt-0">
                    <v-text-field
                      label="Channel / Sales Client Name"
                      v-model="filterObject.channel"
                      dense
                      @keyup.enter="validate"
                    ></v-text-field>
                  </v-col>

                  <!--date picker-->
                  <v-col
                    v-if="!expandChild"
                    cols="8"
                    sm="4"
                    md="4"
                    class="pt-0"
                  >
                    <v-menu
                      ref="orderdate1Menu"
                      v-model="orderdate1Menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="orderdate"
                      transition="scale-transition"
                      offset-y
                      content-class="custom-date-picker"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          ref="onpressdate"
                          :value="orderDateRange"
                          clearable
                          label="Order Date"
                          append-icon="mdi-calendar-month"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          on:focus="onFocus"
                          class="media-exit-cal-input pt-0"
                          @click:clear="orderdate = []"
                          @keyup.enter="validate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="orderdate"
                        :min="orderdate[0]"
                        range
                        dense
                        class="media-exit-date-picker"
                        @change="onChangeorderdate"
                      >
                        <v-btn
                          text
                          color="primary"
                          @click="orderdate1Menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="clickedOkOrder"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="12" class="pt-0">
                    <div>
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col cols="8" sm="4" md="4" class="pt-0">
                                <v-menu
                                  ref="orderdateMenu"
                                  v-model="orderdateMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="orderdate"
                                  transition="scale-transition"
                                  offset-y
                                  content-class="custom-date-picker"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      ref="onpressdate1"
                                      :value="orderDateRange"
                                      clearable
                                      label="Order Date"
                                      append-icon="mdi-calendar-month"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      class="media-exit-cal-input pt-0"
                                      @click:clear="orderdate = []"
                                      @keyup.enter="validate"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="orderdate"
                                    :min="orderdate[0]"
                                    range
                                    dense
                                    class="media-exit-date-picker"
                                    @change="onChange1orderdate"
                                  >
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="orderdateMenu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="clickedOkOrder1"
                                  >
                                    OK
                                  </v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="8" sm="4" md="4" class="pt-0">
                                <v-menu
                                  ref="emailMenu"
                                  v-model="emailMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="email_sent_date"
                                  transition="scale-transition"
                                  offset-y
                                  content-class="custom-date-picker"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      ref="onpressemail"
                                      :value="emailSentDate"
                                      clearable
                                      label="Email Sent Date"
                                      append-icon="mdi-calendar-month"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      class="media-exit-cal-input pt-0"
                                      @click:clear="email_sent_date = []"
                                      @keyup.enter="validate"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="email_sent_date"
                                    :min="email_sent_date[0]"
                                    dense
                                    range
                                    class="media-exit-date-picker"
                                    @change="onChangeEmail"
                                  >
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="emailMenu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="clickedOkEmail"
                                  >
                                    OK
                                  </v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="8" sm="4" md="4" class="pt-0">
                                <v-menu
                                  ref="restoreMenu"
                                  v-model="restoreMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="restoredate"
                                  transition="scale-transition"
                                  offset-y
                                  content-class="custom-date-picker"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      ref="onpressrestore"
                                      :value="restorationDate"
                                      clearable
                                      label="Restoration Complete Date"
                                      append-icon="mdi-calendar-month"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      class="media-exit-cal-input pt-0"
                                      @click:clear="restoredate = []"
                                      @keyup.enter="validate"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="restoredate"
                                    :min="restoredate[0]"
                                    range
                                    dense
                                    class="media-exit-date-picker"
                                    @change="onChangeRestore"
                                  >
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="restoreMenu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="clickedOkRestore"
                                  >
                                    OK
                                  </v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                            <!---ME Order ID ----->
                            <v-row>
                              <v-col cols="8" sm="4" md="4" class="pt-2">
                                <v-text-field
                                  label="ME Order ID"
                                  v-model="filterObject.orderId"
                                  dense
                                  @keyup.enter="validate"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="8" sm="4" md="4" class="pt-2">
                                <v-text-field
                                  label="GPS Order ID"
                                  v-model="filterObject.gps_id"
                                  dense
                                  @keydown.enter="validate"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="8" sm="4" md="4" class="pt-2">
                                <v-select
                                  class="pt-0"
                                  v-model="filterObject.order_status"
                                  :items="orderStatus"
                                  label="Order Status"
                                  @keyup.enter="validate"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="8" sm="4" md="4" class="pt-0">
                                <v-select
                                  class="pt-0"
                                  v-model="filterObject.delivery_method"
                                  :items="deliveryMethods"
                                  label="Delivery Method"
                                  @keyup.enter="validate"
                                ></v-select>
                              </v-col>
                              <v-col cols="8" sm="4" md="4" class="pt-0">
                                <v-select
                                  class="pt-0"
                                  v-model="filterObject.budgetCode"
                                  :items="codes"
                                  label="Budget Code"
                                  @input="budgetCodeSelected"
                                  @keyup.enter="validate"
                                ></v-select>
                              </v-col>
                              <v-col cols="8" sm="4" md="4" class="pt-0">
                                <v-text-field
                                  v-show="isOthersSelected"
                                  label="Type Here"
                                  v-model="othersMessage"
                                  rows="1"
                                  class="pt-0"
                                  @keyup.enter="validate"
                                ></v-text-field>
                              </v-col>
                              <!--date picker-->
                            </v-row>
                          </v-expansion-panel-content>
                          <div class="align-center d-flex">
                            <span>
                              <v-expansion-panel-header
                                :hide-actions="true"
                                @click="expandChild = !expandChild"
                                class="see-more-header"
                              >
                                <v-row no-gutters class="align-center">
                                  <v-col>
                                    <div class="see-more-less">
                                      <div v-if="!expandChild">
                                        See more filters
                                        <v-icon large>mdi-chevron-down</v-icon>
                                      </div>
                                      <div v-if="expandChild">
                                        See less filters
                                        <v-icon large>mdi-chevron-up</v-icon>
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-header>
                            </span>
                            <v-col class="d-flex justify-end">
                              <v-btn
                                class="ma-2 media-exit-sub-btn"
                                color="primary"
                                tile
                                @click="validate"
                                >Submit</v-btn
                              >
                              <v-btn
                                class="my-2 ml-2 media-exit-reset-btn"
                                tile
                                color="default"
                                @click="reset"
                                >Reset All</v-btn
                              >
                            </v-col>
                          </div>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <!--search results-->
        <div v-if="totalrecords === 0" class="d-flex">
          <v-col>
            <div class="media-exit-results">
              {{ 0 }} - {{ 0 }} of {{ 0 }} results
            </div>
          </v-col>
          <v-col>
            <div class="media-exit-no-orderCards">No Records Found</div>
          </v-col>
          <v-col>
            <div class="media-exit-export-all" :disabled="isExportDisabled">
              <div class="text-right media-exit-export-btn" tile color="white">
                <strong
                  >Export All
                  <div
                    class="media-exit-download-icon"
                    :disabled="isExportDisabled"
                  ></div>
                </strong>
              </div>
            </div>
          </v-col>
        </div>
        <div v-else>
          <div class="media-exit-searchResults mt-10">
            <v-row class="justify-space-around-space-around align-center">
              <v-col col="6" sm="6" md="2">
                <div class="media-exit-results">
                  {{ pageStart }} - {{ pageEnd }} of {{ totalrecords }} results
                </div>
              </v-col>
              <v-col col="6" sm="6" md="8">
                <div>
                  <v-pagination
                    class="media-exit-pagination"
                    v-model="currentPage"
                    :length="totalPages"
                    :total-visible="7"
                    @next="nextpage"
                    @input="nextpage"
                    @previous="nextpage"
                  ></v-pagination>
                </div>
              </v-col>
              <v-col col="6" sm="6" md="2">
                <div
                :class="[isDisabled ? 'media-exit-export-all' : 'media-exit-export-btn a']">
                  <div
                    class="text-right media-exit-export-btn"
                    tile
                    color="white"
                  >
                    <a href="javascript:void(0)">
                      <strong @click="exportAll"
                        >Export All
                        <div class="media-exit-download-icon"></div>
                      </strong>
                    </a>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!--order details card-->
          <div class="media-exit-orderCards">
            <v-expansion-panels focusable multiple>
              <v-expansion-panel v-for="(item, i) in orders" :key="i">
                <v-expansion-panel-header>
                  <v-row class="no-gutters">
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        ME Order ID:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="item.order_id"
                      >
                        {{ item.order_id }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Order By:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="item.email_from"
                      >
                        {{ item.email_from }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Order Date:
                      </div>
                      <div class="mx-2 my-2">
                        {{ moment(item.ordered_date).format("DD MMM YYYY") }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Order Status:
                      </div>
                      <div class="mx-2 my-2">{{ item.status }}</div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        GPS Order ID:
                      </div>
                      <div class="mx-2 my-2">{{ item.gps_order_id }}</div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Delivery Method:
                      </div>
                      <div class="mx-2 my-2">{{ item.delivery_method }}</div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Budget Code:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="item.budget_code"
                      >
                        {{ item.budget_code }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Channel / Sales Client Name:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="item.channel"
                      >
                        {{ item.channel }}
                      </div>
                    </v-col>
                    <v-col col="5" md="6">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Subject:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="item.subject"
                      >
                        {{ item.subject }}
                      </div>
                    </v-col>
                    <v-col col="7" md="6">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Message:
                      </div>
                      <div
                        class="ml-2 mr-0 my-2 text-ellipsis-orderHistory"
                        :title="item.message"
                      >
                        {{ item.message }}
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col col="5" sm="5" md="5">
                      <v-row>
                        <v-col>
                          <div class="media-exit-filter-body">Expiry Date:</div>
                          <div>
                            {{ moment(item.expiry_date).format("DD MMM YYYY") }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="media-exit-filter-body">No of Files:</div>
                          <div>{{ item.number_of_files }}</div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="media-exit-filter-body">
                            Max Downloads:
                          </div>
                          <div>{{ item.max_downloads }}</div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="media-exit-filter-body">
                            Receiver List:
                          </div>
                          <div v-for="(reciever, r) in item.receivers" :key="r">
                            <div>{{ reciever[0] }}</div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="media-exit-filter-body">
                            Email Sent Date:
                          </div>
                          <div>
                            <div>
                              {{
                                moment(item.email_sent_date).format(
                                  "DD MMM YYYY"
                                ) === "Invalid date"
                                  ? ""
                                  : moment(item.email_sent_date).format(
                                      "DD MMM YYYY"
                                    )
                              }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="history-file-section" col="7" sm="7" md="7">
                      <!--FILE SECTION STARTS HERE-->
                      <!---------------------------->
                      <div class="file-list-items pa-0">
                        <div
                          class="d-flex file-list"
                          v-for="(orderitem, o) in item.ordered_items"
                          :key="o"
                        >
                          <div class="file-icon">
                            <img
                              src="../../assets/images/file.svg"
                              alt="file"
                              max-width="44"
                              min-width="44"
                            />
                          </div>
                          <div class="file-list-desc-section">
                            <p class="file-list-name">
                              {{ orderitem.s3file.file_name }}
                            </p>
                            <p class="file-list-desc-modified mb-0">
                              Modified:
                              {{
                                moment(orderitem.s3file.last_modified).format(
                                  "DD MMM YYYY, h:mm A"
                                )
                              }}
                              |
                              {{
                                orderitem.s3file.file_size | fileSizeConverter
                              }}
                            </p>
                            <p class="file-list-desc-modified mb-0">
                              Expiry Date:
                              {{
                                moment(orderitem.expiry_date).format(
                                  "DD MMM YYYY"
                                )
                              }}
                              | Max Downloads: {{ orderitem.max_downloads }}
                            </p>
                            <p class="file-list-desc">
                              {{ orderitem.s3file.bucket_name }}/
                              {{ orderitem.s3file.file_name }}
                            </p>
                          </div>
                          <div class="ml-auto text-center">
                            <div
                              class="status-label-big mb-3"
                              :style="{
                                'background-color': getColor(
                                  orderitem.file_status.status
                                )
                              }"
                            >
                              {{ orderitem.file_status.status }}
                            </div>
                            <div v-if="orderitem.restoration_date !== null">
                              <div class="status-sub-title">Restored On</div>
                              <div class="status-label-date">
                                {{
                                  moment(orderitem.restoration_date).format(
                                    "DD MMM YYYY"
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--FILE SECTION END HERE-->
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row style="justify-content: center" class="mb-12">
              <v-col col="10" sm="6" md="8">
                <div class="my-2 justify-center" v-if="totalrecords > 0">
                  <v-pagination
                    class="media-exit-pagination"
                    v-model="currentPage"
                    :length="totalPages"
                    :total-visible="7"
                    @next="nextpage"
                    @input="nextpage"
                    @previous="nextpage"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="media-exit-footer">
          <hr />
          <p>©2020, A&E Television Networks, LLC. All Rights Reserved</p>
        </div>
      </v-container>
    </div>
  </v-app>
</template>
<script>
import moment from "moment";
export default {
  name: "orderHistory",
  props: {
    msg: String
  },
  data() {
    const defaultForm = Object.freeze({
      channel: "",
      pageCount: 0
    });

    return {
      expandChild: false,
      form: Object.assign({}, defaultForm),
      channels: ["channel1", "channel2", "channel3", "channel"],
      codes: [
        {
          text: "A+E International Pays (505100)",
          value: "A+E International Pays & 1000-100050000-444000500-PP-505100",
          disabled: false
        },
        {
          text: "Client Pays (140210)",
          value: "Client Pays & 1000-100050000-000000000-BS-140210",
          disabled: false
        },
        {
          text: "Client Pays (505101)",
          value: "Client Pays & 1000-100050000-444000500-505101",
          disabled: false
        },
        { text: "Other", value: "Other", disabled: false }
      ],
      isOthersSelected: false,
      othersMessage: "",
      orderStatus: [
        {
          text: "Shipped",
          value: "Shipped",
          disabled: false
        },
        {
          text: "In Progress",
          value: "In progress",
          disabled: false
        }
      ],
      deliveryMethods: [
        {
          text: "Aspera Faspex",
          value: "Aspera Faspex",
          disabled: false
        },
        {
          text: "Aspera P2P",
          value: "Aspera P2P",
          disabled: false
        },
        { text: "Signiant", value: "Signiant", disabled: false }
      ],
      defaultForm,
      panel: [1, 0],
      visitDate: [
        v =>
          this.orderdate[0] <= this.orderdate[1] ||
          "Finish Date can't be earlier than Start Date"
      ],
      orderdate1Menu: false,
      orderdateMenu: false,
      emailMenu: false,
      restoreMenu: false,
      dateMenu: false,
      dateMenu2: false,
      dateMenuRange: false,
      expand: false,
      currentPage: 1,
      pageStart: 0,
      totalPages: 0,
      rowsPerPage: 20,
      email_sent_date: [],
      restoredate: [],
      orderdate: [],
      date1: new Date(),
      date2: "",
      order_start_date: "",
      order_end_date: "",
      email_start_date: "",
      email_end_date: "",
      restore_start_date: "",
      restore_end_date: "",
      dateRanges: [],
      emailDate: "",
      restoreDate: "",
      orderDate: "",
      orders: undefined,
      limit: undefined,
      pageEnd: "",
      totalrecords: "",
      filterObject: {
        subject: "",
        filename: "",
        email_from: "",
        receiver_mail: "",
        channel: "",
        budgetCode: "",
        to_date: "",
        from_date: "",
        email_start_date: "",
        email_end_date: "",
        restore_start_date: "",
        restore_end_date: "",
        gps_id: "",
        orderId: "",
        delivery_method: "",
        order_status: "",
        other_code: ""
      },
      queryParam: {
        subject: "",
        file_name: "",
        budget_code: "",
        channel: "",
        email_from: "",
        receiver_mail: "",
        start_date: "",
        end_date: "",
        gps_order_id: "",
        delivery_method: "",
        order_id: "",
        email_start_date: "",
        email_end_date: "",
        restore_start_date: "",
        restore_end_date: "",
        status: "",
        other_code: ""
      },
      next: undefined,
      isDisabled: true
    };
  },
  mounted() {
    this.orderHistoryCall(null, 1);
  },
  computed: {
    isExportDisabled() {
      return this.totalrecords.length === 0;
    },
    fromDate() {
      return this.date1 ? moment(this.date1).format("DD MMM YYYY") : "";
    },
    toDate() {
      return this.date2 ? moment(this.date2).format("DD MMM YYYY") : "";
    },
    emailSentDate() {
      this.email_start_date = this.email_sent_date[0];
      this.email_end_date = this.email_sent_date[1];
         if(this.email_sent_date[1] === 'undefined'){
           this.email_sent_date[1] = this.email_sent_date[0];
         }
      this.emailDate = this.email_sent_date.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.emailDate.join(" - ");
    },
    restorationDate() {
      this.restore_start_date = this.restoredate[0];
      this.restore_end_date = this.restoredate[1];
      this.restoreDate = this.restoredate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.restoreDate.join(" - ");
    },
    orderDateRange() {
      this.order_start_date = this.orderdate[0];
      this.order_end_date = this.orderdate[1];
      this.orderDate = this.orderdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.orderDate.join(" - ");
    },
    expandarrow() {
      let arrow = "rotate-arrow";
      if (this.expand === true) {
        return arrow;
      }
      return this.expand;
    },
    itemsperpage() {
      return (this.currentPage - 1) * 20 + 1;
    }
  },
  methods: {
    onFocus(){
      this.orderdate1Menu = false;
    },
    clickedOkOrder(){
      this.$refs.orderdate1Menu.save(this.orderdate)
      this.$refs["onpressdate"].$refs.input.focus()
      if(this.orderDate.length === 1){
        this.orderdate[1] = this.orderdate[0]
      }
      this.orderDate = this.orderdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.orderDate.join(" - ");
    },
    clickedOkOrder1(){
      this.$refs.orderdateMenu.save(this.orderdate)
      this.$refs["onpressdate1"].$refs.input.focus()
      if(this.orderDate.length === 1){
        this.orderdate[1] = this.orderdate[0]
      }
      this.orderDate = this.orderdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.orderDate.join(" - ");
    },
    clickedOkEmail(){
      this.$refs.emailMenu.save(this.email_sent_date)
      this.$refs["onpressemail"].$refs.input.focus();
      if(this.emailDate.length === 1){
           this.email_sent_date[1] = this.email_sent_date[0];
         }
      this.emailDate = this.email_sent_date.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.emailDate.join(" - ");
    },
    clickedOkRestore(){
      this.$refs.restoreMenu.save(this.restoredate);
      this.$refs["onpressrestore"].$refs.input.focus();
      if(this.restoreDate.length === 1){
        this.restoredate[1] = this.restoredate[0];
      }
      this.restoreDate = this.restoredate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.restoreDate.join(" - ");
    },
    onChangeorderdate(e){
      this.$refs.orderdate1Menu.save(this.orderdate)
      this.$refs["onpressdate"].$refs.input.focus();
    },
    onChange1orderdate(e){
      this.$refs.orderdateMenu.save(this.orderdate)
      this.$refs["onpressdate1"].$refs.input.focus();
    },
    onChangeEmail(e){
      this.$refs.emailMenu.save(this.email_sent_date)
      this.$refs["onpressemail"].$refs.input.focus();
    },
    onChangeRestore(e){
      this.$refs.restoreMenu.save(this.restoredate)
      this.$refs["onpressrestore"].$refs.input.focus();
    },
    exportAll() {
      const domainUrl = "api/export/";
      let vm = this;
      let exportLimit = 1500;
      if (vm.limit > 1499) {
        this.$swal({
          icon: "warning",
          title: `The report is exceeding the maximum limit of ${exportLimit} records. Please refine your search and export the results`,
          type: "success",
          confirmButtonText: "OK",
          showCloseButton: true
        });
      } else {
        this.paramsvalidations(this.queryParam);
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, this.queryParam)
          .then(data => {
            let results = data.data;
            //this.limit = data.data.results.total_files
            let blob = new Blob([results], { type: "text/csv" });
            let link = document.createElement("a");
            let toDate = new Date();
            let getDate = toDate
              .toISOString()
              .slice(0, 10)
              .replace(/-/g, "");
            let todaysDate = moment(getDate).format("DDMMYYYY");
            let getTime = moment().format("HHmmss");
            link.href = window.URL.createObjectURL(blob);
            link.download =
              "Media+Exit_Orders Export_" + todaysDate + "_" + getTime + ".csv";
            link.click();
          });
      }
    },
    orderHistoryCall(params, pageNo) {
      const domainUrl = "api/order/";
      let vm = this;
      this.paramsvalidations(params);
      if (vm.$apiService) {
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, params)
          .then(data => {
            if (data) {
              this.totalrecords = data.data.count;
              this.orders = data.data.results.order_history;
              this.limit = data.data.results.total_files;
              this.orders.forEach(ele => {
                let Odate = ele.ordered_date.split("T")
                ele.ordered_date = Odate[0]
              })
            } else {
              this.totalrecords = 0;
              this.orders = [];
            }
            this.updatePageCount(pageNo, this.totalrecords, this.rowsPerPage);
          });
      }
    },
    paramsvalidations(params){
      if (params) {
        params.start_date = params.start_date === "Invalid date" ? "" : params.start_date;
        params.end_date = params.end_date === "Invalid date" ? "" : params.end_date;

        params.email_start_date = params.email_start_date === "Invalid date" ? "" : params.email_start_date;
        params.email_end_date = params.email_end_date === "Invalid date" ? "" : params.email_end_date;

        params.restore_start_date = params.restore_start_date === "Invalid date" ? "" : params.restore_start_date;
        params.restore_end_date = params.restore_end_date === "Invalid date" ? "" : params.restore_end_date;
      }
    },
    updatePageCount(pageNumber, totalRecords, rowPerPage) {
      this.totalPages =
        totalRecords % rowPerPage
          ? parseInt(totalRecords / rowPerPage) + 1
          : totalRecords / rowPerPage;
      this.pageStart = totalRecords
        ? (parseInt(pageNumber) - 1) * rowPerPage + 1
        : 0;
      this.pageEnd = parseInt(pageNumber - 1) * rowPerPage + this.orders.length;
    },
    getColor(status) {
      if (status === "Cancelled") return "#CB4A5F";
      else if (status === "Expired") return "#CB4A5F";
      else if (status === "Archived") return "#E89D42";
      else if (status === "Restoring") return "#E89D42";
      else return "#80B336";
    },
    setQueryParams() {
      this.filterObject.email_start_date = this.email_start_date;
      let emailendDate;
      if (typeof this.email_end_date !== "undefined") {
        let _end_date = new Date(this.email_end_date);
        _end_date.setDate(_end_date.getDate());
        emailendDate = moment(_end_date).format("YYYY-MM-DD");
      }
      this.filterObject.email_end_date = emailendDate;

      let emailStartDate = typeof this.filterObject.email_start_date === "undefined" ? "" : this.filterObject.email_start_date;
      let emailEndDate = typeof this.filterObject.email_end_date === "undefined" ? "" : this.filterObject.email_end_date;

      this.filterObject.restore_start_date = this.restore_start_date;
      let restoreendDate;
      if (typeof this.restore_end_date !== "undefined") {
        let _end_date = new Date(this.restore_end_date);
        _end_date.setDate(_end_date.getDate());
        restoreendDate = moment(_end_date).format("YYYY-MM-DD");
      }
      this.filterObject.restore_end_date = restoreendDate;
      let restoreStartDate = typeof this.filterObject.restore_start_date === "undefined" ? "" : this.filterObject.restore_start_date;
      let restoreEndDate = typeof this.filterObject.restore_end_date === "undefined" ? "" : this.filterObject.restore_end_date;

      this.filterObject.order_start_date = this.order_start_date;
      let orderendDate;
      if (typeof this.order_end_date !== "undefined") {
        let _end_date = new Date(this.order_end_date);
        _end_date.setDate(_end_date.getDate() + 1);
        orderendDate = moment(_end_date).format("YYYY-MM-DD");
      }
      this.filterObject.order_end_date = orderendDate;
      let OrderStartDate = typeof this.filterObject.order_start_date === "undefined" ? "" : this.filterObject.order_start_date;
      let OrderEndDate = typeof this.filterObject.order_end_date === "undefined" ? "" : this.filterObject.order_end_date;

      //for budget code other selected
      if (
        this.filterObject.budgetCode === "Other" &&
        this.othersMessage !== ""
      ) {
        this.filterObject.budgetCode = "Other";
        this.filterObject.other_code = this.othersMessage;
      } else if (
        this.filterObject.budgetCode === "Other" &&
        this.othersMessage === ""
      ) {
        this.filterObject.budgetCode = "Other";
        this.filterObject.other_code = "";
      }

      this.queryParam.subject = this.filterObject.subject;
      this.queryParam.file_name = this.filterObject.filename;
      this.queryParam.budget_code = this.filterObject.budgetCode;
      this.queryParam.channel = this.filterObject.channel;
      this.queryParam.email_from = this.filterObject.email_from;
      this.queryParam.receiver_mail = this.filterObject.receiver_mail;

      //for order date ranges
      this.queryParam.start_date = OrderStartDate;
      this.queryParam.end_date = OrderEndDate;
      //for email sent date ranges
      this.queryParam.email_start_date = emailStartDate;
      this.queryParam.email_end_date = emailEndDate;
      // for restoration complete date ranges
      this.queryParam.restore_start_date = restoreStartDate;
      this.queryParam.restore_end_date = restoreEndDate;

      this.queryParam.status = this.filterObject.order_status;
      this.queryParam.order_id = this.filterObject.orderId;
      this.queryParam.delivery_method = this.filterObject.delivery_method;
      this.queryParam.gps_order_id = this.filterObject.gps_id;
      this.queryParam.other_code = this.filterObject.other_code;
    },
    validate() {
      this.currentPage = 1;
      this.setQueryParams();
      this.orderHistoryCall(this.queryParam, 1);
      this.isDisabled = false;
    },
    reset() {
      this.currentPage = 1;
      this.filterObject.subject = "";
      this.filterObject.filename = "";
      this.filterObject.email_from = "";
      this.filterObject.receiver_mail = "";
      this.filterObject.channel = "";
      this.filterObject.budgetCode = "";
      this.date1 = "";
      this.date2 = "";
      //added filters from here
      this.filterObject.order_status = "";
      this.filterObject.orderId = "";
      this.filterObject.delivery_method = "";
      this.filterObject.gps_id = "";
      this.orderdate = [];
      this.email_sent_date = [];
      this.restoredate = [];
      this.email_start_date = "";
      this.email_end_date = "";
      this.restore_start_date = "";
      this.restore_end_date = "";
      this.order_end_date = "";
      this.order_start_date = "";
      this.filterObject.email_start_date = "";
      this.filterObject.email_end_date = "";
      this.othersMessage = "";
      this.isOthersSelected = false;
      this.filterObject.other_code = ""
      this.setQueryParams();
      this.orderHistoryCall(null, 1);
      this.isDisabled = true;
    },
    nextpage(e) {
      let queryParam = {
        subject: this.queryParam.subject,
        file_name: this.queryParam.file_name,
        budget_code: this.queryParam.budget_code,
        channel: this.queryParam.channel,
        email_from: this.queryParam.email_from,
        receiver_mail: this.queryParam.receiver_mail,
        start_date: this.queryParam.start_date,
        end_date: this.queryParam.end_date,
        email_start_date: this.queryParam.email_start_date,
        email_end_date: this.queryParam.email_end_date,
        restore_start_date: this.queryParam.restore_start_date,
        restore_end_date: this.queryParam.restore_end_date,
        status: this.queryParam.status,
        order_id: this.queryParam.order_id,
        delivery_method: this.queryParam.delivery_method,
        other_code: this.queryParam.other_code,
        page: this.currentPage
      };
      this.orderHistoryCall(queryParam, this.currentPage);
    },
    budgetCodeSelected() {
      if (this.filterObject.budgetCode === "Other") {
        this.isOthersSelected = true;
      } else if (
        this.filterObject.budgetCode ===
        "Client Pays & 1000-100050000-000000000-BS-140210"
      ) {
        this.isOthersSelected = false;
      } else if (
        this.filterObject.budgetCode ===
        "A+E International Pays & 1000-100050000-444000500-PP-505100"
      ) {
        this.isOthersSelected = false;
      } else if (
        this.filterObject.budgetCode ===
        "Client Pays & 1000-100050000-444000500-505101"
      ) {
        this.isOthersSelected = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../Orderer/orderHistory.scss";
</style>
<style lang="scss">
@import "../Orderer/orderHistory_unscoped.scss";
</style>
